import { ChangeEvent } from 'react';

export const mustMatch = (setter: (val: string) => void, regexp: RegExp) => (
  value: string
) => (value?.match(regexp) ? setter(value) : undefined);

export const pipeEvent = <T>(next: (arg: string) => T) => (
  event: ChangeEvent<HTMLInputElement>
) => next(event.target.value);
